export const HONEY_TOWER_DISPLAY_SCALE = 0.5
export const HONEY_WATER_SURFACE_ALPHA = 0.28

// Coordinates are local to the 128×128 source anchored at source y=122.
export const HONEY_WATER_APERTURE = {
  centerX: 0,
  centerY: -42,
  radiusX: 40,
  radiusY: 13,
} as const

export const HONEY_FISH_PATHS = [
  { centerX: -12, centerY: -42, radiusX: 8, radiusY: 1, phase: 0 },
  { centerX: 12, centerY: -42, radiusX: 8, radiusY: 1, phase: 7 },
] as const
